/*
 * enfoque-components.js
 * ---------------------------------------------------------------------------
 * Runtime for the interactive product components (C1–C10,
 * design_handoff_enfoque_components). Deferred, loaded after theme.js/cart.js.
 * Document-delegated so it survives Theme-Editor section re-renders.
 *   - C10 coupon: copy code to clipboard (+ "Copiado!" confirmation)
 *   - C5 modal:   payment-methods tabs (Cartão / Boleto / Pix)
 *   - C5 modal:   re-sync on variant change (its figures depend on the price)
 * Upgrade-safe new file.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  /* ==== C5 · Payment modal — re-sync on variant change ================ *
   * The price itself lives in `#price-<sectionId>`, which cart.js already swaps
   * from the Section-Rendering-API HTML, so nothing is needed for it here. The
   * modal is a SIBLING of that node (it has to be — modals.js moves it out of
   * the DOM while open), so the swap misses it, yet its installment table and
   * Pix/boleto figures are price-dependent. Swap it by id from the same fetched
   * HTML. No client-side money math.
   *
   * Skipped while the modal is open: modals.js has relocated it into
   * .mfp-content and appended a close button *inside* it, so replacing
   * innerHTML then would destroy that button. A variant cannot be changed while
   * the overlay covers the picker anyway — this is belt and braces.            */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var d = event && event.data;
      if (!d || !d.html) return;
      document.querySelectorAll('.enfc-paymodal[id]').forEach(function (dest) {
        if (dest.closest('.mfp-content')) return;          // open — leave it alone
        var src = d.html.getElementById(dest.id);
        if (src) dest.innerHTML = src.innerHTML;
      });
    });
  }

  /* ==== C10 · Coupon copy-to-clipboard ================================= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-enfc-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-enfc-copy');
    var done = function () {
      var code_el = btn.querySelector('.enfc-coupon__code');
      if (!code_el || btn.classList.contains('copied')) return;
      var prev = code_el.textContent;
      btn.classList.add('copied');
      code_el.textContent = 'Copiado!';
      setTimeout(function () {
        btn.classList.remove('copied');
        code_el.textContent = prev;
      }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () { done(); });
    } else {
      // fallback: hidden textarea + execCommand
      try {
        var ta = document.createElement('textarea');
        ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); document.execCommand('copy');
        document.body.removeChild(ta);
      } catch (err) { /* no-op */ }
      done();
    }
  });

  /* ==== C5 · Payment modal — tabs ===================================== */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.enfc-paymodal__tab');
    if (!tab) return;
    var modal = tab.closest('.enfc-paymodal');
    if (!modal) return;
    var key = tab.getAttribute('data-tab');
    modal.querySelectorAll('.enfc-paymodal__tab').forEach(function (t) {
      t.classList.toggle('active', t === tab);
    });
    modal.querySelectorAll('.enfc-paymodal__panel > div').forEach(function (p) {
      p.classList.toggle('active', p.getAttribute('data-panel') === key);
    });
  });
})();
